export default __webpack_public_path__ + "static/media/DSKDWT.f3601784.png";